<pw-view-title *ngIf="!filterAll">{{'orders.ordersList.openOrders' | translate}}</pw-view-title>
<pw-view-title *ngIf="filterAll">{{'orders.ordersList.allOrders' | translate}}</pw-view-title>
<pw-view-actions>
  <button mat-icon-button (click)="openSearchDialog()">
    <mat-icon>find_in_page</mat-icon>
  </button>
  <button mat-icon-button (click)="toggleFilter()">
    <mat-icon *ngIf="!filtered">search</mat-icon>
    <mat-icon *ngIf="filtered" matBadge="{{getFilterBadgeCount()}}" matBadgeColor="accent">filter_alt</mat-icon>
  </button>

</pw-view-actions>

<pw-view-drawer>
  <div class="ps-flex-container-col">
    <mat-form-field>
      <mat-label>{{'orders.ordersList.from' | translate}}</mat-label>
      <input matInput [matDatepicker]="pickerFilterStart" [(ngModel)]="filterStart">
      <mat-datepicker-toggle matSuffix [for]="pickerFilterStart">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerFilterStart></mat-datepicker>
    </mat-form-field>

    <mat-form-field>
      <mat-label>{{'orders.ordersList.to' | translate}}</mat-label>
      <input matInput [matDatepicker]="pickerFilterEnd" [(ngModel)]="filterEnd">
      <mat-datepicker-toggle matSuffix [for]="pickerFilterEnd">
        <mat-icon matDatepickerToggleIcon>keyboard_arrow_down</mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #pickerFilterEnd></mat-datepicker>
    </mat-form-field>

    <mat-form-field *ngIf="channels">
      <mat-label>{{'orders.ordersList.channel' | translate}}</mat-label>
      <mat-select [(ngModel)]="filterChannel" [compareWith]="compareChannels">
        <mat-option *ngFor="let channel of channels" [value]="channel.OBJECT_ID">
          {{channel.NAME}}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-checkbox [(ngModel)]="filterAll">{{'orders.ordersList.filterAllOrders' | translate}}?</mat-checkbox>
    <mat-checkbox [(ngModel)]="filterChanged">{{'orders.ordersList.onlyChanged' | translate}}</mat-checkbox>

    <div>
      <button mat-button color="primary" (click)="executeFilter();toggleFilter()">
        {{'orders.ordersList.filter' | translate}}
      </button>
      <button mat-button color="primary" (click)="resetFilter();toggleFilter()">
        {{'orders.ordersList.reset' | translate}}
      </button>
    </div>
  </div>
</pw-view-drawer>

<mat-form-field>
  <mat-label>Filter</mat-label>
  <input type="text" matInput placeholder="Filter" [formControl]="searchFormControl">
</mat-form-field>

<div *ngIf="deliveryPbos$ | async; else loadingOrders; let pbos" class="ps-grid-3-col">

  <mat-card *ngFor="let pbo of pbos"
            [ngClass]="[suppliersService.hasOrderChanged(pbo) ? 'order-changed' : '', suppliersService.isOrderDelivered(pbo) ? 'order-delivered' : '']">
    <mat-card-header>
      <img mat-card-avatar src="{{pbo.ICON_URL}}">
      <mat-card-title style="font-weight: bold">{{pbo.NAME}}</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="ps-grid-2-col">
        <div>{{'orders.ordersList.project' | translate}}: {{pbo.PROJEKTNAME}}</div>
        <div>{{'orders.ordersList.supplier' | translate}}: {{pbo.LIEFERANT}}</div>
        <div>{{'orders.ordersList.date' | translate}}: {{pbo.TERMIN | date}}</div>
        <div>{{'orders.ordersList.status' | translate}}: {{pbo.LIEFERSTATUS}}</div>
        <div>{{'orders.ordersList.channel' | translate}}: {{pbo.CHANNELNAME}}</div>
        <div>{{'orders.ordersList.orderNumber' | translate}}: {{pbo.EXTBESTELLNR}}
          <button mat-button (click)="setCommissionNr(pbo.OBJECT_ID)" color="primary">
            <mat-icon>edit</mat-icon>
          </button>
        </div>
      </div>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-button color="primary" routerLink="/orders/{{pbo.OBJECT_ID}}/overview"
              matTooltip="{{'orders.ordersList.ordersOverview' | translate}}">
        <mat-icon>fact_check</mat-icon>
      </button>
    </mat-card-actions>
  </mat-card>
</div>

<ng-template #loadingOrders>
  <h3 *ngIf="isLoading">{{'orders.ordersList.loadingOrders' | translate}}.</h3>
  <h3 *ngIf="!isLoading && (deliveryPbos$ | async).length === 0">{{'orders.ordersList.noOrders' | translate}}</h3>
</ng-template>
